import { TerminalOperatorManagementState, RequestState } from './terminal-operator-management.actions';

export const initialRequestState: RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialState: TerminalOperatorManagementState = {
  terminalOperatorDashboard: { ...initialRequestState },
  terminals: { ...initialRequestState },
  terminalsByCompany: { ...initialRequestState },
  deleteTerminalRequest: { ...initialRequestState },
  productUsages: { ...initialRequestState },
  unitOfMeasures: { ...initialRequestState },
  terminalStockReports: { ...initialRequestState },
  terminalDailyStock: { ...initialRequestState },
  terminalStockSubmit: { ...initialRequestState },
  terminalUsageStockUpdate: { ...initialRequestState },
  terminalTankStockSubmit: { ...initialRequestState },
  terminalDailySummary: { ...initialRequestState },
  terminalTankStatusUpdate: { ...initialRequestState },
  terminalStockStatusUpdate: { ...initialRequestState },
  terminalTankUpdate: { ...initialRequestState },
  currentDailyStock: { ...initialRequestState },
  submitTerminalReport: { ...initialRequestState },
  updateTerminalStockUsage: { ...initialRequestState },
  findAllProductUnitConversions: { ...initialRequestState },
  deleteTank: { ...initialRequestState },
};
